document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".size_guide_tabs button");
    const categories = document.querySelectorAll(".size_guide_category");

    function showCategory(categoryId) {
      categories.forEach(category => {
        category.style.display = category.id === categoryId ? "block" : "none";
      });

      tabs.forEach(button => {
        button.classList.toggle("active", button.dataset.target === categoryId);
      });

      history.replaceState(null, null, "#" + categoryId);
    }

    tabs.forEach(button => {
      button.addEventListener("click", function () {
        showCategory(this.dataset.target);
      });
    });

    const initialCategory = window.location.hash.replace("#", "") || categories[0]?.id;
    if (initialCategory) {
      showCategory(initialCategory);
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    const tables = document.querySelectorAll(".size_guide_table");
  
    tables.forEach(table => {
      table.addEventListener("mouseover", function (event) {
        const cell = event.target.closest(".size_guide_table_cell"); 
        if (!cell) return;
  
        const row = cell.parentElement;
        const colIndex = [...row.children].indexOf(cell);
        if (colIndex === -1) return;
  
        const rows = table.querySelectorAll(".size_guide_table_row");
        const headerRow = table.querySelector(".size_guide_table_head tr");
  
        row.classList.add("hovered-row");
  
        rows.forEach(row => {
          const columnCell = row.children[colIndex];
          if (columnCell) {
            columnCell.classList.add("hovered-column");
          }
        });
  
        if (headerRow) {
          const headerCell = headerRow.children[colIndex];
          if (headerCell) {
            headerCell.classList.add("hovered-column");
          }
        }
  
        cell.classList.add("hovered-cell");
      });
  
      table.addEventListener("mouseout", function () {
        table.querySelectorAll(".hovered-row").forEach(row => {
          row.classList.remove("hovered-row");
        });
  
        table.querySelectorAll(".hovered-column").forEach(cell => {
          cell.classList.remove("hovered-column");
        });
  
        table.querySelectorAll(".hovered-cell").forEach(cell => {
          cell.classList.remove("hovered-cell");
        });
      });
    });
  });
  